import React, { useEffect, useState } from "react";
import EvaluatingTable from "./ApplicantTableComponent/EvaluatingTable";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { getallapplicant, reset } from "../../features/Applicant/applicantSlice";
import swal from "sweetalert";

const ApplicantEvaluation = () => {
  const [resetID, setResetID] = useState(false)
  const dispatch = useAppDispatch();

  const {
    EvalvationisSuccess,
    UpdateScreeningStatusisSuccess,
    sendOfferisSuccess,
    applicationInterviewisSuccess,
    updateApplicationInterviewStatusisSuccess,
    sendEmailisSuccess,
    shareApplicationisSuccess,
    ScreeningisSuccess,
    applicationassignedisSuccess,
    scheduleApplicantisSuccess,
    updateInterviewStatusisSuccess,
    UpdateOfferisSuccess,
    sendForHireisSuccess,
    EditapplicantionisSuccess,
    sendForTranningisSuccess,
    updateTranningisSuccess,
    data,
    isError,
    isLoading,
    message,
  } = useAppSelector((state: { applicant: any }) => state.applicant);

  useEffect(() => {
    if (
      EvalvationisSuccess ||
      UpdateScreeningStatusisSuccess ||
      sendOfferisSuccess ||
      applicationInterviewisSuccess ||
      updateApplicationInterviewStatusisSuccess ||
      sendEmailisSuccess ||
      shareApplicationisSuccess ||
      ScreeningisSuccess ||
      applicationassignedisSuccess ||
      scheduleApplicantisSuccess ||
      updateInterviewStatusisSuccess ||
      UpdateOfferisSuccess ||
      sendForHireisSuccess ||
      EditapplicantionisSuccess ||
      sendForTranningisSuccess ||
      updateTranningisSuccess
    ) {
      const input = { applicationStatus: "SCREENING" };
      // @ts-ignore 
      dispatch(getallapplicant(input))

      setTimeout(() => {
        dispatch(reset());
      }, 2000);
    }
  }, [EvalvationisSuccess, UpdateScreeningStatusisSuccess, sendOfferisSuccess, applicationInterviewisSuccess, updateApplicationInterviewStatusisSuccess, sendEmailisSuccess, shareApplicationisSuccess, ScreeningisSuccess, applicationassignedisSuccess, scheduleApplicantisSuccess, updateInterviewStatusisSuccess, dispatch, UpdateOfferisSuccess, sendForHireisSuccess, EditapplicantionisSuccess, sendForTranningisSuccess, updateTranningisSuccess]);



  useEffect(() => {
    const input = { applicationStatus: "SCREENING" };
    // @ts-ignore 
    dispatch(getallapplicant(input))

  }, [dispatch]);


  useEffect(() => {
    if (isError) {
      swal({
        title: "error",
        text: message,
        icon: "error"
      })
      dispatch(reset())
    }
  }, [dispatch, isError, message])



  return (
    <div>
      <EvaluatingTable
        statusButton={"view-Evaluating-status"}
        Status={"Test"}
        pageHeader={"Evaluating"}
        message={message}
        data={data}
        isError={isError}
        isLoading={isLoading} 
        setResetID={setResetID}
        headerTitles={[
          "",
          "Edit",
          "Update",
          "Applicant Name",
          "Gender",
          "Date Of Birth",
          "Job Profile",
          "View ID",
          "Applied on",
          "Last Updated on",
          "Status",
          "Stage",
          "Email",
          "Phone Number",
          "Location",
          "Edit"
        ]}
      />
    </div>
  );
};

export default ApplicantEvaluation;
